// actions.js
import * as actionTypes from "./actionsTypes";

export const setValueModelePmes = (value) => ({
  type: actionTypes.SET_VALUE_ModelePmes,
  payload: value,
});

export const setTypeModelePmes = (type) => ({
  type: actionTypes.SET_TYPE_ModelePmes,
  payload: type,
});
export const setActifModelePmes = (actif) => ({
  type: actionTypes.SET_ACTIF_ModelePmes,
  payload: actif,
});

export const setCurrentPageModelePmes = (page) => ({
  type: actionTypes.SET_CURRENT_PAGE_ModelePmes,
  payload: page,
});

export const setOrderModelePmes = (order) => ({
  type: actionTypes.SET_ORDER_ModelePmes,
  payload: order,
});

export const setSortFieldModelePmes = (field) => ({
  type: actionTypes.SET_SORT_FIELD_ModelePmes,
  payload: field,
});
export const setCategorieModelePmes = (categorie) => ({
  type: actionTypes.SET_CATEGORIE_ModelePmes,
  payload: categorie,
});
